// extracted by mini-css-extract-plugin
module.exports = {"container":"_CnL-BU2","inner":"_bvqKbOr","announcement":"_1TQTtc1","preview":"_htn4t-f","title":"_k8lvVF4","readMore":"_3nqN1Yc","close":"_3KabxKz","content":"_8yWDGnF"};